module.exports = __webpack_public_path__ + "img/Desk Stationary A25.b7491851.jpg";